export default "__VITE_ASSET__CVpmhD53__"